import { AgendaDia } from '../interfaces/agenda-dia';

type AgendaRotulavel = Pick<AgendaDia, 'dsAgenda' | 'nmMedico' | 'tipoAgenda' | 'dsEspecialidade'>;

// Tipos do Tasy (AGENDA.CD_TIPO_AGENDA): 3 = consulta, 2 = exame. Outros não ganham rótulo.
export function rotuloTipoAgenda(tipo: number | null | undefined): string {
  if (tipo === 3) return 'Consulta';
  if (tipo === 2) return 'Exame';
  return '';
}

// O mesmo médico pode ter agenda de consulta e de exame, cada uma com sua fila. Sem o tipo (back
// antigo) e com o nome repetido, cai na descrição da agenda para as linhas continuarem distintas.
export function detalheAgendaDia(a: AgendaRotulavel, todas: AgendaRotulavel[]): string {
  const partes = [rotuloTipoAgenda(a.tipoAgenda), a.dsEspecialidade ?? ''].filter(p => !!p?.trim());
  if (partes.length > 0) return partes.join(' · ');
  if (a.tipoAgenda == null && a.nmMedico && todas.filter(o => o.nmMedico === a.nmMedico).length > 1) {
    return a.dsAgenda ?? '';
  }
  return '';
}
